export const UPDATE_POPUP_PLAYER = 'UPDATE_POPUP_PLAYER';
export const POPUP_PLAYER_READY = 'POPUP_PLAYER_READY';
export const RECONNECT_POPUP_PLAYER = 'RECONNECT_POPUP_PLAYER';
export const UPDATE_POPUP_PLAYER_CONSENT = 'UPDATE_POPUP_PLAYER_CONSENT';
